import * as sdk from '@cypro/server/sdk'
import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'

type Input = sdk.GetPatientsTherapiesTherapyDateActionsCountData['query']

const options = {
  placeholderData: keepPreviousData,
  staleTime: 5 * 60 * 1000,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: true,
}

export function currentUserActionsCountQueryOptions(input?: Input) {
  return queryOptions({
    queryKey: ['current-user-actions-count', input],
    queryFn: async () => {
      const {data} = await sdk.getPatientsTherapiesCurrentActionsCount({query: input})
      return data?.count ?? 0
    },
    ...options,
  })
}

export function useCurrentUserActionsCount(input?: Input) {
  const {data, ...rest} = useQuery({...currentUserActionsCountQueryOptions(input)})
  return {...rest, actionsCount: data}
}

export function therapyDateActionsCountQueryOptions(input?: Input) {
  return queryOptions({
    queryKey: ['therapy-date-actions', input],
    queryFn: async () => {
      const {data} = await sdk.getPatientsTherapiesTherapyDateActionsCount({
        query: input,
      })
      return data?.count ?? 0
    },
    ...options,
  })
}

export function useTherapyDateActionsCount(input?: Input) {
  const {data, ...rest} = useQuery({...therapyDateActionsCountQueryOptions(input)})
  return {...rest, actionsCount: data}
}
